var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUseLandscape = function SvgUseLandscape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m1.952 17.337 5.096-6.808 3.98 5.307h8.02l-5-6.65-2.75 3.647-.942-1.247 3.692-4.922 8 10.673zm3-1.5h4.202l-2.106-2.82z"
  })));
};
export default SvgUseLandscape;